import Swiper from 'swiper'
if (window.innerWidth <= 768) {
  const containers = document.querySelectorAll('.different-size-teaser')
  containers.forEach(container => {
    new Swiper(container, {
      slidesPerView: 1.3,
      slideClass: 'different-size-teaser-element',
      wrapperClass: 'different-size-teaser-container',
      breakpoints: {
        480: {
          slidesPerView: 3
        }
      }
    })
  })
}
